import React from 'react';

import classes from './SeatsNavItem.scss';

const seatsNavItem = (props) => <li {...props} className={[classes.Item, props.active === 'true' ? classes.ItemActive : null].join(' ')}>{props.children}</li>;

export default seatsNavItem;


// WEBPACK FOOTER //
// ./src/components/Addons/Seats/SeatsNav/SeatsNavItem/SeatsNavItem.js